import type { Catalog } from '../types';

export const rounds = {
  'rounds.filter.period.30d': { pt: '30 dias', en: '30 days' },
  'rounds.filter.period.6m': { pt: '6 meses', en: '6 months' },
  'rounds.filter.period.year': { pt: 'Este ano', en: 'This year' },
  'rounds.filter.period.all': { pt: 'Tudo', en: 'All' },

  'rounds.filter.status.all': { pt: 'Todas', en: 'All' },
  'rounds.filter.status.completed': { pt: 'Concluídas', en: 'Completed' },
  'rounds.filter.status.inProgress': { pt: 'Em andamento', en: 'In progress' },
  'rounds.filter.status.abandoned': { pt: 'Abandonadas', en: 'Abandoned' },

  'rounds.title': { pt: 'Voltas', en: 'Rounds' },
  'rounds.record': { pt: 'Registrar volta', en: 'Record round' },
  'rounds.best': { pt: 'Melhor volta', en: 'Best round' },
  'rounds.noneInFilter': { pt: 'Nenhuma volta no filtro', en: 'No rounds match the filter' },
  'rounds.clearFilters': { pt: 'Limpar filtros', en: 'Clear filters' },

  'rounds.filterTitle': { pt: 'Filtrar voltas', en: 'Filter rounds' },
  'rounds.filter.periodLabel': { pt: 'Período', en: 'Period' },
  'rounds.filter.allCourses': { pt: 'Todos os campos', en: 'All courses' },

  /** A barra de filtros permanente do desktop, onde cada grupo ganha rótulo e o `select`, `aria`. */
  'rounds.filter.statusLabel': { pt: 'Status', en: 'Status' },
  'rounds.filter.statusAria': { pt: 'Filtrar por status', en: 'Filter by status' },
  'rounds.filter.holesLabel': { pt: 'Buracos', en: 'Holes' },
  'rounds.filter.holesAria': {
    pt: 'Filtrar por número de buracos',
    en: 'Filter by number of holes',
  },
  'rounds.filter.bothHoles': { pt: '9 e 18', en: '9 and 18' },
  'rounds.filter.periodAria': { pt: 'Filtrar por período', en: 'Filter by period' },
  'rounds.filter.allPeriods': { pt: 'Todo o período', en: 'All time' },
  'rounds.filter.courseAria': { pt: 'Filtrar por campo', en: 'Filter by course' },
  'rounds.filter.clear': { pt: 'Limpar', en: 'Clear' },

  'rounds.active.meta': {
    pt: '{started} · {holes} buracos · Tee {tee}',
    en: '{started} · {holes} holes · Tee {tee}',
  },
  'rounds.active.progress': {
    pt: '{scored} de {holes} buracos',
    en: '{scored} of {holes} holes',
  },
  'rounds.continue': { pt: 'Continuar', en: 'Continue' },

  'rounds.table.course': { pt: 'Campo e data', en: 'Course and date' },
  'rounds.table.strokes': { pt: 'Tacadas', en: 'Strokes' },
  'rounds.table.par': { pt: 'Par', en: 'Par' },
  /** *Score differential*, abreviado — a coluna tem a largura de um número de duas casas. */
  'rounds.table.sd': { pt: 'SD', en: 'SD' },
  'rounds.table.open': { pt: 'Abrir', en: 'Open' },
  'rounds.rowMeta': {
    pt: '{date} · {holes} buracos · Tee {tee}',
    en: '{date} · {holes} holes · Tee {tee}',
  },
  'rounds.rowAbandoned': { pt: ' · abandonada', en: ' · abandoned' },
  'rounds.groupBadge': {
    pt: { one: 'Em grupo · {count} jogador', other: 'Em grupo · {count} jogadores' },
    en: { one: 'Group · {count} player', other: 'Group · {count} players' },
  },

  /** Botão "marcar todas" da barra de seleção — não é o filtro de status. */
  'rounds.selectAll': { pt: 'Todas', en: 'All' },
  'rounds.select': { pt: 'Selecionar', en: 'Select' },
  'rounds.selectRounds': { pt: 'Selecionar voltas', en: 'Select rounds' },
  'rounds.exitSelection': { pt: 'Sair da seleção', en: 'Leave selection' },
  'rounds.selectedCount': {
    pt: { one: '{count} selecionada', other: '{count} selecionadas' },
    en: { one: '{count} selected', other: '{count} selected' },
  },

  'rounds.finishCount': {
    pt: { one: 'Finalizar {count} volta', other: 'Finalizar {count} voltas' },
    en: { one: 'Finish {count} round', other: 'Finish {count} rounds' },
  },
  'rounds.abandonCount': {
    pt: { one: 'Abandonar {count} volta', other: 'Abandonar {count} voltas' },
    en: { one: 'Abandon {count} round', other: 'Abandon {count} rounds' },
  },
  'rounds.finishConfirmTitle': {
    pt: { one: 'Finalizar {count} volta?', other: 'Finalizar {count} voltas?' },
    en: { one: 'Finish {count} round?', other: 'Finish {count} rounds?' },
  },
  'rounds.abandonConfirmTitle': {
    pt: { one: 'Abandonar {count} volta?', other: 'Abandonar {count} voltas?' },
    en: { one: 'Abandon {count} round?', other: 'Abandon {count} rounds?' },
  },
  'rounds.finishAction': { pt: 'Finalizar', en: 'Finish' },
  'rounds.abandonAction': { pt: 'Abandonar', en: 'Abandon' },
  'rounds.keep': { pt: 'Manter as voltas', en: 'Keep the rounds' },
  'rounds.back': { pt: 'Voltar', en: 'Back' },
  'rounds.completedCount': {
    pt: { one: '{count} concluída', other: '{count} concluídas' },
    en: { one: '{count} completed', other: '{count} completed' },
  },
  'rounds.inProgressCount': { pt: '{count} em andamento', en: '{count} in progress' },
  'rounds.pageOfCompleted': {
    pt: '{shown} de {total} voltas concluídas',
    en: '{shown} of {total} completed rounds',
  },
  'rounds.pageOfFiltered': {
    pt: '{shown} de {total} voltas no filtro',
    en: '{shown} of {total} rounds in the filter',
  },
  'rounds.finishRest': {
    pt: 'As demais precisam ser completadas ou abandonadas.',
    en: 'The rest need to be completed or abandoned.',
  },
  'rounds.confirmFinish': {
    pt: 'Seu handicap será recalculado e estas voltas não poderão mais ser editadas.',
    en: 'Your handicap will be recalculated and these rounds can no longer be edited.',
  },
  'rounds.confirmAbandon': {
    pt: 'Os buracos preenchidos serão descartados e as voltas não contarão para o handicap.',
    en: 'The holes you filled in will be discarded and the rounds will not count towards your handicap.',
  },
  'rounds.finishRequirement': {
    pt: 'Só é possível fechar uma volta com todos os buracos preenchidos, ou com exatamente 9 de 18.',
    en: 'A round can only be closed with every hole filled in, or with exactly 9 of 18.',
  },
  'rounds.finished': {
    pt: { one: '{count} volta finalizada', other: '{count} voltas finalizadas' },
    en: { one: '{count} round finished', other: '{count} rounds finished' },
  },
  'rounds.abandoned': {
    pt: { one: '{count} volta abandonada', other: '{count} voltas abandonadas' },
    en: { one: '{count} round abandoned', other: '{count} rounds abandoned' },
  },
  'rounds.handicapRecalculated': { pt: 'handicap recalculado', en: 'handicap recalculated' },
  'rounds.skippedNotEnough': {
    pt: '{count} sem buracos suficientes',
    en: '{count} without enough holes',
  },

  /**
   * O estado vazio da lista, explicando **qual** filtro esvaziou.
   *
   * Uma chave por combinação, e não fragmentos concatenados. A versão anterior empilhava pedaços
   * em minúscula num array e juntava com espaço — "Você não tem voltas concluídas de 18 buracos nos
   * últimos 30 dias." Isso depende da ordem das palavras do português e não sobrevive a outro
   * idioma: em inglês o período vem antes do tipo, e o número de buracos vira adjetivo.
   *
   * São oito combinações porque são três filtros binários no texto, e escrevê-las por extenso é o
   * preço de uma frase que se lê bem nos dois idiomas.
   */
  'rounds.empty.none': { pt: 'Você ainda não tem voltas.', en: 'You have no rounds yet.' },
  'rounds.empty.status': {
    pt: 'Você não tem voltas {status}.',
    en: 'You have no {status} rounds.',
  },
  'rounds.empty.holes': {
    pt: 'Você não tem voltas de {holes} buracos.',
    en: 'You have no {holes}-hole rounds.',
  },
  'rounds.empty.period': {
    pt: 'Você não tem voltas nos últimos {period}.',
    en: 'You have no rounds in the last {period}.',
  },
  'rounds.empty.statusHoles': {
    pt: 'Você não tem voltas {status} de {holes} buracos.',
    en: 'You have no {status} {holes}-hole rounds.',
  },
  'rounds.empty.statusPeriod': {
    pt: 'Você não tem voltas {status} nos últimos {period}.',
    en: 'You have no {status} rounds in the last {period}.',
  },
  'rounds.empty.holesPeriod': {
    pt: 'Você não tem voltas de {holes} buracos nos últimos {period}.',
    en: 'You have no {holes}-hole rounds in the last {period}.',
  },
  'rounds.empty.statusHolesPeriod': {
    pt: 'Você não tem voltas {status} de {holes} buracos nos últimos {period}.',
    en: 'You have no {status} {holes}-hole rounds in the last {period}.',
  },
} as const satisfies Catalog;
